import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getSummary (params) {
    return request.get(API.MANAGER_VENDOR_SUMARY, params)
  },
  getRankingUser (params) {
    return request.get(API.MANAGER_RANKING_USER, params)
  },
  getRankingFile (params) {
    return request.get(API.MANAGER_RANKING_FILE, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/manager/dashboard.js